{
  "acsSlow": {
    "body": "We are putting you in contact with the operator of your payment method for transaction authorization.",
    "title": "Waiting for a response from your bank…"
  },
  "app": {
    "title": "Pay a notice - pagoPA"
  },
  "ariaLabels": {
    "appLanguage": "Set language",
    "close": "Close",
    "editCard": "Change card details",
    "editDonation": "Change donation institution",
    "editPsp": "Change payment service provider (PSP)",
    "informationDialog": "Information on the commission fee",
    "informationLink": "To learn more about the campaign",
    "languageMenu": "Selected language",
    "loading": "Loading",
    "applySorting": "Apply selected order",
    "sortingDefault": "Default order",
    "sortingName": "Order by name",
    "sortingAmount": "Order by amount"
  },
  "cancelledPage": {
    "body": "The operation was canceled",
    "button": "Close"
  },
  "authCallbackPage": {
    "title": "It was not possible to sign in",
    "body": "A problem occurred during sign in. Please try again in a few minutes.",
    "buttons": {
      "retry": "Try again",
      "continueWithoutLogin": "Continue without signing in"
    }
  },
  "authExpiredPage": {
    "title": "Your session expired",
    "body": "Sign in to resume your session, or continue without signing in ",
    "buttons": {
      "login": "Sign in",
      "continueWithoutLogin": "Continue without signing in."
    }
  },
  "cartDetail": {
    "amount": "Amount",
    "companyName": "Payee",
    "description": "Payment description",
    "fiscalCode": "Payee tax code",
    "iuv": "IUV code",
    "noticeNumber": "Notice code"
  },
  "clipboard": {
    "copied": "Copied",
    "copy": "Copy",
    "edit": "Change"
  },
  "DOMAIN_UNKNOWN": {
    "title": "The payee is having problems with the response",
    "buttons": {
      "close": "Close",
      "help": "Contact support"
    }
  },
  "DONATIONLIST_ERROR": "We were not able to load the list of organizations.",
  "donationPage": {
    "click": "press",
    "code": "and scan the code:",
    "description": "You have until 23 December to donate. You can donate with your card without fees. The amount will be paid directly to the account of the organization to which you choose to donate.",
    "dismissCTA": "Show organizations",
    "dismissDescription": "If you want, you can donate to one of the humanitarian organizations that joined the initiative.",
    "dismissTitle": "The service is no longer active",
    "entity": "Who do you want to donate to?",
    "ioDescription": "Donate with the IO app to receive an email with information concerning tax benefits.",
    "modalBody2": "You can donate with your cards without fees.",
    "modalTitle": "Continue to the IO app",
    "openSection": "Open the section",
    "payNotice": "Pay a notice",
    "portfolio": "Wallet",
    "submitCard": "Donate with your card",
    "submitIO": "Donate with IO",
    "title": "Donate for the crisis in Ukraine",
    "volunteer": "How much do you want to donate?"
  },
  "errorButton": {
    "close": "Close",
    "help": "Contact support",
    "retry": "Try again"
  },
  "ErrorCodeDescription": "Error code for support",
  "GENERIC_ERROR": {
    "body": "Try again or contact support.",
    "title": "An unexpected error occurred"
  },
  "general": {
    "and": "and"
  },
  "indexPage": {
    "description": "You can pay by card, bank account or payment app. You will receive the payment result via email.",
    "title": "Pay a notice"
  },
  "iframeCardPage": {
    "helpLink": "Where do I find the CVV?",
    "modalTitle": "Where do I find the CVV?",
    "modalBodyText": "The CVV code (or CVC) has 3 digits and is located on the back of your card.<br>On American Express cards, the code (CID) has 4 digits and is located on the front.",
    "buttonClose": "Close"
  },
  "inputCardPage": {
    "formErrors": {
      "cid": "Enter 4 digits",
      "cvv": "Enter 3 digits",
      "expirationDate": "Enter mm/yy",
      "name": "Enter name as shown on the card",
      "number": "Enter a valid number",
      "required": "Required"
    },
    "formFields": {
      "cid": "CID (4 digits)",
      "cvv": "CVV",
      "expirationDate": "Expiration date",
      "name": "Card holder",
      "number": "Card number",
      "required": "Required"
    },
    "helpLink": "Where can I find the security code?",
    "modal": {
      "description": "It is a three-digit code, called CVV or CVS, which you can find on the back of your card.",
      "descriptionAE": "On American Express cards, the code (CID) has four digits and is located on the front.",
      "title": "Security code"
    },
    "title": "Enter card information"
  },
  "INVALID_CARD": {
    "body": "Try to enter valid card information or contact us for help if necessary.",
    "title": "We are sorry, the card is not valid"
  },
  "INVALID_DECODE": {
    "body": "Try again or contact us for help.",
    "title": "There was an error reading the data"
  },
  "INVALID_QRCODE": {
    "body": "If the problem continues, try entering the information manually.",
    "title": "The scanned code is not a pagoPA notice"
  },
  "koPage": {
    "body": "No amount was charged.",
    "button": "Close",
    "helpButton": "Do you need help?",
    "learnMoreButton": "Learn More",
    "title": "An unexpected error occurred"
  },
  "mainPage": {
    "footer": {
      "accessibility": "Accessibility",
      "help": "Help",
      "privacy": "Privacy",
      "terms": "Terms",
      "platformStatus": "Platform status",
      "pagoPA": "Visit the pagoPA website"
    },
    "header": {
      "login": "Sign in",
      "logout": "Log out",
      "detail": {
        "detailButton": "Open payment summary",
        "detailFC": "Payee tax code",
        "detailIUV": "IUV code",
        "detailAmount": "Subtotal",
        "detailReceiver": "Payee",
        "detailSubject": "Payment description",
        "detailTitle": "Notice detail"
      },
      "disclaimer": "The amount is updated automatically, therefore you will always pay what is due and avoid arrears or other interest."
    },
    "main": {
      "skipToContent": "Skip to main content"
    }
  },
  "NOTLISTED": {
    "body": "Try again or contact us for help.",
    "title": "An unexpected error occurred"
  },
  "PAYMENT_CANCELED": {
    "body": "Contact the payee for more information.",
    "title": "The payee revoked this notice"
  },
  "PAYMENT_DATA_ERROR": {
    "title": "The data entered are incorrect"
  },
  "PAYMENT_DUPLICATED": {
    "body": "If you paid on this website, the confirmation was sent to the email address you indicated during payment.",
    "title": "This notice was already paid!"
  },
  "PAYMENT_EXPIRED": {
    "body": "Contact the payee for more information.",
    "title": "The notice has expired and it can no longer be paid"
  },
  "PAYMENT_ONGOING": {
    "body": "If the problem continues, report it to us!",
    "title": "A payment is already in progress, try again later"
  },
  "PAYMENT_UNAVAILABLE": {
    "title": "There is a technical problem with this notice"
  },
  "PAYMENT_UNKNOWN": {
    "body": "The notice may have already been paid. To get support, contact the Payee.",
    "title": "We can’t find the notice"
  },
  "pspUnavailable": {
    "body": "This error might occur when the amount to be paid is particularly high, or if you’re trying to pay for a digital tax stamp.",
    "cta": {
      "primary": "Choose another method"
    },
    "title": "The selected method is not available"
  },
  "paymentEmailPage": {
    "description": "You will receive the payment result at this address",
    "formButtons": {
      "back": "Go back",
      "submit": "Continue"
    },
    "formErrors": {
      "invalid": "Enter a valid email address",
      "notEqual": "The email addresses do not match",
      "required": "Required field"
    },
    "formFields": {
      "confirmEmail": "Repeat again",
      "email": "Email address"
    },
    "title": "Enter your email"
  },
  "findOutMoreModal": {
    "title": "What to do if the payment fails?",
    "section1Title": "1. Pay the notice",
    "section1ContentRow1": "Remember to pay the notice by the deadline set by the issuing authority.",
    "section1ContentRow2": "If you’re unable to proceed through this site, ",
    "section1ContentRow2Link": "discover the other channels enabled for pagoPA.",
    "section2Title": "2. Wait for the refund",
    "section2ContentRow1": "The amount is usually refunded within a few minutes.",
    "section2ContentRow2": "In other cases, the transfer of money to your account or card could take more time.",
    "section3Title": "3. Contact support",
    "section3ContentRow1": "If you have not received the refund after 5 business days, ",
    "section3ContentRow2Link": "contact support."
  },
  "paymentResponsePage": {
    "0": {
      "body": "We have sent the payment confirmation to {{useremail}}",
      "title": "You have paid {{amount}}"
    },
    "1": {
      "body": "No amount was charged.",
      "title": "An unexpected error occurred."
    },
    "2": {
      "body": "No amount was charged. Check you have correctly followed the instructions from your bank.",
      "title": "Authorization denied"
    },
    "3": {
      "body": "If you paid using a debit or credit card, make sure to enter the data as shown on the front of the card.",
      "title": "The payment method information is not correct"
    },
    "4": {
      "body": "No amount was charged. For your security, you have a limited amount of time to complete the operation.",
      "title": "The session has expired"
    },
    "5": {
      "title": "The card circuit is not supported"
    },
    "6": {
      "title": "Some data is missing in order to proceed with the payment"
    },
    "7": {
      "body": "Contact your bank for more information.",
      "title": "The payment method has expired or is no longer valid"
    },
    "8": {
      "body": "No amount was charged.",
      "title": "The operation was canceled"
    },
    "10": {
      "body": "No amount was charged. You have probably exceeded the limits set by your bank.",
      "title": "Authorization denied"
    },
    "12": {
      "title": "The payment method is not supported"
    },
    "17": {
      "body": "You will receive the payment result at the address {{useremail}}.",
      "title": "Wait for payment confirmation"
    },
    "18": {
      "body": "The authorized amount has been refunded to your payment method. The transfer of money could take some time.",
      "title": "The payment was unsuccessful"
    },
    "25": {
      "body": "No amount was charged.\n If the problem continue, try using another payment method or provider.",
      "title": "The payment was unsuccessful"
    },
    "116": {
      "body": "No amount was charged. Before trying again, add funds to your card or use another payment method.",
      "title": "Your card balance is insufficient"
    },
    "117": {
      "body": "No amount was charged. The code (CVV or CVC) has 3 digits and is located on the back of the card. If you use American Express, the code (CID) has 4 digits and is on the front.",
      "title": "The security code entered is incorrect."
    },
    "121": {
      "body": "No amount was charged. Before trying again, change the spending limit or use another payment method.",
      "title": "You have exceeded your card’s spending limit."
    },
    "3dsNotInitiated": {
      "body": "No amount was charged.\n If the problem continues, contact the operator of the payment method, your bank for example.",
      "title": "There was a problem with the operator of your payment method"
    },
    "buttons": {
      "continue": "Continue",
      "findOutMode": "Find out more"
    },
    "survey": {
      "body": "Tell us about your experience with the payment and help us improve.",
      "link": {
        "href": "https://pagopa.qualtrics.com/jfe/form/SV_0jllXJcXhmSpb38",
        "text": "Go to the survey"
      },
      "title": "Could you share your experience with us?"
    }
  },
  "paymentCheckPage": {
    "buttons": {
      "cancel": "Cancel",
      "submit": "Pay",
      "wait": "Wait…"
    },
    "creditCard": "Pay with",
    "disclaimer": {
      "cheaper": "Suggested because least expensive",
      "yourCard": "Suggested because you are already a customer",
      "psp": "By continuing, you accept the <terms>Terms and Conditions of Use</terms> and confirm that you have read the <privacy>Privacy Policy</privacy> of <psp>{{pspName}}</psp>"
    },
    "drawer": {
      "body": "This list contains all the operators compatible with your method, even if you are not their customer.",
      "header": {
        "amount": "Fee",
        "name": "Operator"
      },
      "title": "Which operator do you want to use for payment?",
      "selectPspAccessibilityLabel": "Select {{pspName}} as payment provider",
      "pspNameAccessibilityLabel": "Sort alphabetically by provider name",
      "taxFeeAccessibilityLabel": "Sort from the lowest fee amount"
    },
    "email": "Send the result to:",
    "modal": {
      "body": "All money transfer operations (cash or electronic currency) have a cost that is used to guarantee that the payment is safe and successful.\nEvery operator (or PSP, Payment Service Provider) indicates a cost, according to their commercial policies and contractual conditions.\nWith pagoPA, these costs are transparent and the citizen can freely select the most convenient and affordable option. To learn more, consult the page ",
      "cancelBody": "If you quit, any data you have entered will be deleted and you will have to start again.",
      "cancelButton": "No, I changed my mind",
      "cancelTitle": "Your payment is pending, do you want to exit?",
      "link": "Cost transparency",
      "submitButton": "Exit",
      "title": "Why is there a fee?"
    },
    "psp": "Applied by",
    "total": "Total",
    "transaction": "Fee"
  },
  "paymentChoicePage": {
    "saved": "Saved",
    "bank": "Bank account",
    "button": "Back",
    "costs": "Cost transparency.",
    "creditCard": "Debit or credit card",
    "description": "To learn more about the methods and costs applied by the participating operators, visit the page ",
    "incoming": "Coming soon",
    "others": "Other methods",
    "showMore": "Unavailable methods",
    "title": "How do you want to pay?",
    "feeRange": "Fee: from {{min}}  to {{max}}",
    "feeSingle": "Fee: {{value}}",
    "filterLabel": "Search a method",
    "noPaymentMethodsAvailable": "No results found. Try with another keyword.",
    "filterButton": "Filter",
    "drawer": {
      "title": "Filter Methods",
      "byType": "By type",
      "byFunc": "By features",
      "card": "Card",
      "balance": "Bank account",
      "appApm": "App and other methods",
      "payByPlan": "Installment payment",
      "showResults": "Show results",
      "remove": "Clear all filters"
    }
  },
  "paymentMethods": {
    "bpay": "BANCOMAT Pay",
    "cc": "Bank account",
    "cp": "Debit or credit card",
    "ppay": "Pay with Postepay"
  },
  "paymentNoticeChoice": {
    "form": {
      "description": "Notice code and payee tax code",
      "title": "Enter your data"
    },
    "qr": {
      "description": "Use your webcam or camera",
      "title": "Scan the QR code"
    }
  },
  "paymentNoticePage": {
    "description": "Enter the data as show on the payment notice.",
    "exampleModalAltText": "pagoPA payment notice, with the hightlighted section showing the notice code and the tax code of the creditor entity.",
    "exampleModalTitle": "Example of a pagoPA notice",
    "formButtons": {
      "cancel": "Back",
      "submit": "Continue"
    },
    "formErrors": {
      "minCf": "Enter 11 numbers",
      "minCode": "Enter 18 numbers",
      "required": "Required field"
    },
    "formFields": {
      "billCode": "Notice code",
      "cf": "Payee tax code"
    },
    "helpLink": "View an example",
    "title": "What do you have to pay?"
  },
  "paymentPspListPage": {
    "title": "Choose who will handle the payment",
    "description": "Each provider offers a fee. In this list, you will find all compatible providers, <strong>even if you are not their customer</strong>.",
    "operator": "Provider",
    "alreadyClient": "Client already",
    "formButtons": {
      "back": "Back",
      "submit": "Continue"
    },
    "sort": "Sort",
    "drawer": {
      "sorting": {
        "default": "Default",
        "name": "By name",
        "amount": "By amount"
      },
      "showResults": "Apply"
    },
    "myBankAlertTitle": "Can't find your bank?",
    "myBankAlertBody": "Don't worry: you'll select it in the next steps."
  },
  "paymentQrPage": {
    "camBlocked": "We need your consent to use the camera. To change your selection, go to your browser’s privacy settings",
    "description": "Make sure to have good lighting. If the code is not in focus, try to move it away slightly from the screen.",
    "navigate": "Not working? Enter it manually",
    "reloadPage": "Reload the page",
    "title": "Scan the QR code",
    "usageHintPc": "This page requires the use of a QR code reader. To scan the QR code, allow the browser access to the camera when prompted. You may need to use an external or built-in webcam. The QR code must be well framed and well lit to facilitate reading.",
    "usageHintMobile": "This page requires the use of a QR code reader. To scan the QR code, allow the browser to access the camera when prompted. Use your smartphone’s rear camera and point it at the QR code. The QR code must be well framed and well lit to ensure it can be read properly."
  },
  "paymentSummaryPage": {
    "amount": "Amount updated",
    "billCode": "Notice code",
    "buttons": {
      "cancel": "Back",
      "ok": "OK",
      "submit": "Go to the payment"
    },
    "causal": "Payment description",
    "cf": "Payee tax code",
    "creditor": "Payee",
    "description": "When the amount changes, it means it has been updated automatically. If it is higher, there may be interest, penalties, or notification costs.\n\nIf the pagoPA notice concerns a legally significant communication, the increase in the amount to be paid may depend on various factors, such as:\n• receiving the communication via registered mail (as printing and delivery costs may be charged to the recipient);\n• the number of delivery attempts.\n\nFor further details, contact the Payee.",
    "dialog": {
      "description": "When the amount changes, it means it has been updated automatically. If it is higher, there may be interest, penalties, or notification costs.\n\nIf the pagoPA notice concerns a legally significant communication, the increase in the amount to be paid may depend on various factors, such as:\n• receiving the communication via registered mail (as printing and delivery costs may be charged to the recipient);\n• the number of delivery attempts.\n\nFor further details, contact the Payee.",
      "title": "Is the amount different from the one on the pagoPA notice?"
    },
    "iuv": "IUV code",
    "title": "Payment data"
  },
  "POLLING_SLOW": {
    "body": "Please wait a few minutes without reloading the page.",
    "title": "The payee is taking more time than usual..."
  },
  "privacyInfo": {
    "googleDesc": "Form protected by reCAPTCHA and Google.",
    "privacyDesc": "By continuing you accept the service <terms>terms and conditions of use</terms> and confirm to have read the <privacy>Privacy Policy</privacy>",
    "privacyDonation": "Additional terms of the Donation service in favor of the emergency in Ukraine"
  },
  "STATUS_ERROR": {
    "body": "If the problem continues, report it to us!",
    "title": "An unexpected error occurred"
  },
  "TIMEOUT": {
    "body": "If the problem continues, report it to us!",
    "title": "The payee is having problems with the response"
  },
  "errorMessageNPG": {
    "HF0001": "Enter 3 or 4 digits",
    "HF0002": "Service temporarily unavailable",
    "HF0003": "The session has expired, go back and try again",
    "HF0004": "Enter a valid number",
    "HF0005": "The network of this card is not supported",
    "HF0006": "Enter mm/yy",
    "HF0007": "Enter name as shown on the card",
    "HF0009": "3DS verification failed"
  },
  "userSession": {
    "logoutModal": {
      "title": "Are you sure you want to log out?",
      "body": "You can still pay even when you're not logged in.",
      "submitButton": "Log out",
      "cancelButton": "Cancel"
    }
  },
  "ScheduledMaintenanceBanner": {
    "titleKey": "Scheduled maintenance",
    "bodyKey": "It will not be possible to make payments from 00:01 to 03:00 on 18 July 2025.",
    "linkTextKey": "More information"
  },
  "maintenancePage": {
    "title": "We're working for you",
    "subtitle": "pagoPa is currently not available due to scheduled maintenance.",
    "closeButton": "Close",
    "detailsButton": "Find out more"
  },
  "__variant-name": "Inglese",
  "__variant-description": ""
}